import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { TableColumn } from '@shared/interface/table.interface';
import { BaseDatasource } from '@shared/base/base.datasource';
import { BehaviorSubject, Subscription } from 'rxjs';
import { UtilitiesService } from '@services/utilities.service';
import { BaseService } from '@services/base-service.service';
import { ICardProductNeedFullFill, ICodeValue, IOrderItem } from '@shared/components/card/card-product-need-full-fill/card-product-need-full-fill.interface';
import { BaseTableService } from '@shared/base/base-table-service.service';
import { STRING_CONSTANTS } from '@config/constants/string.constants';
import { ModalComponent } from '@shared/components/modal/modal.component';
import { ModalConfig } from '@shared/components/modal/modal.interface';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-card-product-need-full-fill',
  templateUrl: './card-product-need-full-fill.component.html',
  styleUrls: ['./card-product-need-full-fill.component.scss'],
})
export class CardProductNeedFullFillComponent implements OnInit, OnDestroy {
  @Input() url!: string;
  @Input() value!: ICardProductNeedFullFill;
  @Input() tableColumns: TableColumn[];
  @Input() isSalesOrder: boolean = false;

  isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  data: BehaviorSubject<ICardProductNeedFullFill> = new BehaviorSubject<ICardProductNeedFullFill>({} as ICardProductNeedFullFill);
  listProduct: IOrderItem[];
  salesOrderCode: ICodeValue[];

  // table
  displayedColumns: string[];

  baseDatasource: BaseDatasource<ICardProductNeedFullFill>;

  // approval modal
  @ViewChild('modalDetailSO') modalDetailSO: ModalComponent;
  modalConfigSO: ModalConfig = {
    modalTitle: 'Hadiah Belum Dikirim',
  };

  get dataValue() {
    return this.data.value;
  }

  set dataValue(value) {
    this.data.next(value);
  }

  private unsubscribe: Subscription[] = [];

  constructor(
    public utilities: UtilitiesService,
    private activeRoute: ActivatedRoute,
    private baseService: BaseService,
    private baseTableService: BaseTableService<ICardProductNeedFullFill>,
    private ref: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    const data = this.baseTableService.responseDatabase.subscribe((response) => {
      this.baseDatasource = response;
    });
    this.setTableData();
    this.getData();
    this.unsubscribe.push(data);
  }

  setTableData() {
    this.displayedColumns = this.tableColumns.map((item) => item.key);
  }

  getData() {
    this.isLoading.next(true);
    const data = this.baseService.getData<ICardProductNeedFullFill>(this.url).subscribe((res) => {
      if (res && res.success) {
        this.dataValue = res.data;
        if (this.isSalesOrder) {
          this.listProduct = this.dataValue.order_items_list;
        } else {
          this.listProduct = this.dataValue.order_items_list.filter((item) => (item.total_price > 0 && item.total_price) || item.is_bonus);
        }
        setTimeout(() => {
          this.isLoading.next(false);
          this.ref.detectChanges();
        }, 750);
      }
    });
    this.unsubscribe.push(data);
  }

  handleNoImage = (e: Event) => this.utilities.setDefaultImageProduct(e);

  handleModalDetail(item: IOrderItem) {
    this.salesOrderCode = item.sales_order_source_list;
    this.modalConfigSO = {
      ...this.modalConfigSO,
      modalTitle: 'Hadiah Belum Dikirim - ' + item.product_name,
    };
    return this.modalDetailSO.open();
  }

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }

  protected readonly STRING_CONSTANTS = STRING_CONSTANTS;
  protected readonly BehaviorSubject = BehaviorSubject;
}
